import React from "react";

export default function BuiltByPeople() {
  return (
    <section className="mu-section text-center">
      <div className="container">
        <div className="mu-badge-pill mx-auto mb-3">How We Started</div>
        <h2 className="section-title mx-auto" style={{ maxWidth: "560px" }}>
          Built by People Who Love the Culture
        </h2>
        <p className="section-sub mx-auto">
          MusicUntamed started with a simple observation: African artists were creating some of
          the most exciting music in the world, but the tools to distribute, promote, and present
          that music professionally weren't built with them in mind. We set out to change that —
          one release, one EPK, one playlist placement at a time.
        </p>
      </div>
    </section>
  );
}
